/** A megerősítő link tokenje a fragmentben van (`#t=<32 hexa karakter>`); más alak esetén null. */
export function tokenFragmentbol(hash: string): string | null {
  return hash.match(/^#t=([0-9a-f]{32})$/)?.[1] ?? null;
}
